import { useEffect, useState } from "react";
import { AiFillClockCircle } from "react-icons/ai";
import logo from "../../assests/logo.png";
import { useStores } from "../../store";
export default function Header(props) {
  const branch = localStorage.getItem("branch");
  const { MockStore, PopupStore } = useStores();
  const totalMinutes =
    MockStore.aptitude.length +
    MockStore.reasonong.length +
    MockStore.verbals.length +
    MockStore.core.length;
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  const [time, setTime] = useState({
    hours: hours,
    minutes: minutes,
    seconds: 0,
  });
  const [isActive, setIsActive] = useState(true); // Start timer automatically

  useEffect(() => {
    let interval = null;

    if (isActive) {
      interval = setInterval(() => {
        if (time.hours === 0 && time.minutes === 0 && time.seconds === 0) {
          clearInterval(interval);
          setIsActive(false);
          alert("Timer Completed!"); // Show alert when timer completes
        } else if (time.minutes === 0 && time.seconds === 0) {
          setTime({
            hours: time.hours - 1,
            minutes: 59,
            seconds: 59,
          });
        } else if (time.seconds === 0) {
          setTime({
            ...time,
            minutes: time.minutes - 1,
            seconds: 59,
          });
        } else {
          setTime({
            ...time,
            seconds: time.seconds - 1,
          });
        }
      }, 1000);
    } else if (
      !isActive &&
      (time.hours !== 0 || time.minutes !== 0 || time.seconds !== 0)
    ) {
      clearInterval(interval);
    } else if (time.hours === 0 && time.minutes === 0 && time.seconds === 0) {
      clearInterval(interval);
      alert("Timer Completed!"); // Show alert when timer completes
      setIsActive(false); // Stop the timer
      PopupStore.setMcq(true);
    }

    return () => clearInterval(interval);
  }, [isActive, time]);

  const resetTimer = () => {
    setTime({ hours: 1, minutes: 29, seconds: 0 });
    setIsActive(true); // Restart timer
  };

  return (
    <>
      <div className="flex md:flex-row lg:flex-row flex-col justify-between  md:p-10 lg:p-10 p-5  md:gap-0 lg:gap-0 gap-2">
        <div className="flex flex-col md:gap-0 lg:gap-0 gap-2 ">
          <img src={logo} className="md:hidden w-[58%]"></img>
          <span className="font-semibold text-lg whitespace-nowrap text-primary md:text-black">
            {branch} Mock test
          </span>
        </div>
        <span className="w-[40%] hidden md:block">
          <span className="flex flex-row justify-between items-center">
            <p>Progress</p>
            <span className="text-primary">
              {props.ans}/{props.que} completed
            </span>
          </span>
          <span className=" max-w-full ">
            <div className="border border-primary  rounded-full h-4 min-w-[90%]">
              <div
                className="bg-primary h-full rounded-full lg:text-xl"
                style={{ width: `${props.score}%` }}
              ></div>
            </div>
          </span>
        </span>
        <span className="flex flex-row items-center gap-2 md:ml-0 lg:ml-0 ml-auto md:mr-0 lg:mr-0 mr-4 ">
          <AiFillClockCircle className="text-primary text-2xl"></AiFillClockCircle>
          <h1 className="font-bold">{`${time.hours
            .toString()
            .padStart(2, "0")}:${time.minutes
            .toString()
            .padStart(2, "0")}:${time.seconds
            .toString()
            .padStart(2, "0")}`}</h1>
        </span>
      </div>
    </>
  );
}
